var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark-badge-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M117.899 117.958H117.958H117.899ZM117.899 117.958C114.033 121.792 107.027 120.837 102.113 120.837C96.0826 120.837 93.1784 122.017 88.8741 126.321C85.2094 129.986 80.2961 136.583 74.4994 136.583C68.7026 136.583 63.7894 129.986 60.1244 126.321C55.8202 122.017 52.916 120.837 46.8851 120.837C41.9719 120.837 34.9658 121.792 31.0999 117.958C27.2031 114.094 28.1621 107.059 28.1621 102.114C28.1621 95.8654 26.7955 92.9921 22.3455 88.542C15.7259 81.9227 12.4161 78.6124 12.416 74.5C12.4161 70.387 15.7258 67.0773 22.3453 60.4578C26.3177 56.4854 28.1621 52.5491 28.1621 46.8857C28.1621 41.9724 27.2073 34.9662 31.041 31.1003C34.9053 27.2035 41.9404 28.1626 46.8852 28.1626C52.5484 28.1626 56.4848 26.3184 60.457 22.3461C67.0767 15.7264 70.3863 12.4167 74.4994 12.4167C78.6124 12.4167 81.922 15.7264 88.5414 22.3461C92.5128 26.3175 96.4489 28.1626 102.113 28.1626C107.027 28.1626 114.033 27.2078 117.899 31.0417C121.796 34.9059 120.836 41.9409 120.836 46.8857C120.836 53.1345 122.204 56.0077 126.653 60.4578C133.273 67.0773 136.583 70.387 136.583 74.5C136.583 78.6124 133.273 81.9227 126.653 88.542C122.203 92.9921 120.836 95.8654 120.836 102.114C120.836 107.059 121.796 114.094 117.899 117.958Z",
    fill: "#262F71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.875 80.0434L67.05 90.0208L93.125 58.9792",
    stroke: "#FFC909",
    strokeWidth: 12.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessicon);
export default __webpack_public_path__ + "static/media/successicon.98f98b37b7d96fe69145a1f1fba4a75c.svg";
export { ForwardRef as ReactComponent };